export const environment = {
    production: false,
    apiUrl: 'https://test-api-admin-portal.vlinkgroup.net/api'
};
